<template>
  <iframe
    id="benefitsOverview"
    width="100%"
    height="500px"
    referrerpolicy="strict-origin"
    sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    title="hospitalSearch"
    :src="$t(`products.${props.productId}.benefitPath`)"
  />
</template>

<script setup>
// INIT
  const props = defineProps({
    productId: {
      type: String,
      required: true,
    },
  })
</script>

<style scoped>
#benefitsOverview,
#hospitalSearch {
  border: none;
}
</style>
